var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18.125,
    viewBox: "0 0 15 18.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#575757;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    id: "Fill",
    strokeWidth: "0.1Q",
    d: "M13.75,10.625A6.25,6.25,0,1,1,7.5,4.375h3.863L9.125,6.619,10,7.5l3.75-3.75L10,0,9.125.881l2.244,2.244H7.5a7.5,7.5,0,1,0,7.5,7.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/Redo.0da0ee78090cebc4bf4775a98952fa26.svg";
export { ForwardRef as ReactComponent };